/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import * as React from "react";
import { useEffect, useState } from "react";
// react-router-dom components
import { Link, useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// sweetalert2 components
import Swal from "sweetalert2";

// @mui material components
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import { styled } from "@mui/system";
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftBadge from "components/SoftBadge";
import SoftSelect from "components/SoftSelect";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
//import DataTable from "Tables/FiltersList";
import DataTable from "Tables/DataTable";
import CheckObjectDeletion from "Modals/CheckObjectDeletion";

// ProductsList page components
import ActionCell from "views/general-filters-list/components/ActionCell";
import { getData, delData, putData } from "Utils/server";
import { getAuthorizationHeader, getUserData } from "Utils/helpers";
import { useSoftUIController } from "context";
import { Alert, Snackbar } from "@mui/material";

/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    maxWidth: 500,
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
  },
}));

let currentData = [];
let marketsFilters = [];
let oddSettingsOptions = [];
let marketSettingsOptions = [];

let oddSettingsEditCached = false;
let oddSettingsShowCached = false;
let defaultStaticOddReactionJson = { value: 0, operator: "+" };

/**
 *
 * @param {*} param0
 * @returns
 */
function GeneralFiltersList({ templateId }) {
  const abortController = new AbortController();

  const userData = getUserData();
  const [controller, dispatch] = useSoftUIController();
  const { platform, sports, permissions } = controller;
  const location = useLocation();

  const [templatesOptions, setTemplatesOptions] = useState([]);
  const [selectedTemplateOption, setSelectedTemplatesOption] = useState({ value: 0, label: "All" });
  const [selectedTemplateOptionId, setselectedTemplateOptionId] = useState(0);
  const [templateToEdit, setTemplateToEdit] = useState(null);
  const [platformId, setPlatformId] = useState(0);
  const [showCreateModal, setDeleteModal] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(0);

  const [oddSettingToEdit, setOddSettingToEdit] = useState(0);
  const [showOddFilterCreateModal, setShowOddFilterCreateModal] = useState(false);
  const [recordSelectedProvider, setRecordSelectedProvider] = useState(null);
  const [recordSelectedTemplate, setRecordSelectedTemplate] = useState("0");
  const [recordSelectedTemplateName, setRecordSelectedTemplateName] = useState("0");
  const [filtersSelections, setFiltersSelection] = useState([]);
  const [filterIdSelected, setFilterIdSelected] = useState(null);
  const [marketSettingsAvailable, setMarketSettingsAvailable] = useState(null);

  const [referenceToDelete, setReferenceToDelete] = useState("filter");
  const [userPermissions, setUserPermissions] = useState(null);
  const [oddSettingsEdit, setOddSettingsEdit] = useState(false);
  const [oddSettingsShow, setOddSettingsShow] = useState(false);

  const [newTemplateName, setNewTemplateName] = useState("");
  const [loading, setLoading] = useState(true);
  const [dataTableData, setDataTableData] = useState({
    columns: [
      // { Header: "id", accessor: "id", width: "100px" },
      { Header: "selected", accessor: "selected", width: "100px" },
      { Header: "filter", accessor: "filter", width: "100px" },
      { Header: "template", accessor: "template", width: "100px", Cell: showEnabled },
      { Header: "providers", accessor: "providers", width: "120px" },
      { Header: "types", accessor: "types", Cell: makeList, width: "120px" },
      { Header: "sports", accessor: "sports", Cell: makerollover, width: "120px" },
      { Header: "competitions", accessor: "competitions", width: "120px" },
      {
        Header: "Markets Setting",
        width: "100px",
        Cell: formatMarketsSetting,
        accessor: "markets_filter_config_id",
      },
      {
        Header: "Odds Settings inplay",
        accessor: "odds_filter_inplay_id",
        width: "120px",
        Cell: formatOddSettingInplay,
      },
      {
        Header: "Odds Settings pregame",
        accessor: "odds_filter_pregame_id",
        width: "120px",
        Cell: formatOddSettingPregame,
      },
      { Header: "action", accessor: "action", width: "120px" },
    ],

    rows: [],
  });

  const [hiddenColumns, setHiddenColumns] = useState([
    "selected",
    "odds_filter_inplay_id",
    "odds_filter_pregame_id",
  ]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [oddSettingsAvailable, setSettingsAvailable] = useState(null);
  const [notification, setNotification] = useState(false);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");
  const [showDialog, setShowDialog] = useState(false);
  const [updateEnabled, setUpdateEnabled] = useState(false);

  const mixingOptions = [
    { value: 0, label: "No Mixing" },
    { value: 1, label: "Highest Price" },
    { value: 2, label: "Percentage Weight" },
  ];

  const oddsReactions = [
    { value: 0, label: "Do Nothing" },
    { value: 1, label: "Suspend Odds" },
    { value: 2, label: "Set Odds to Limits" },
    { value: 3, label: "Suspend Market" },
  ];

  const marginOptions = [
    { value: 0, label: "No Margin" },
    { value: 1, label: "All odds get same margin (EM)" },
    { value: 2, label: "Highest odds get more margin (MPTO)" },
    { value: 3, label: "Lowest odds get more margin (MPTP)" },
  ];

  const oddsSuspensionType = [
    { value: 0, label: "Never" },
    { value: 1, label: "One Provider Suspend Odd" },
    { value: 2, label: "All Providers Suspend Odd" },
    { value: 3, label: "The Most off the Providers Suspend Odd" },
    { value: 4, label: "Ordered Providers Suspend Odd" },
    { value: 5, label: "Price is higher than the sorted Providers" },
  ];

  function makeOddSettingsRollover({ value, ...rest }) {
    let listItems = [
      { key: "min Price", value: rest.row.original.lowerlimit_inplay },
      { key: "max Price", value: rest.row.original.upperlimit_inplay },
    ];

    if (rest.column.Header === "Odds Limit Reaction") {
      listItems = [
        { key: "min Price", value: rest.row.original.lowerlimit_inplay },
        { key: "max Price", value: rest.row.original.upperlimit_inplay },
      ];
    }

    if (rest.column.Header === "Mixing Type") {
      if (value == "No Mixing") return <>{value}</>;
      listItems = [
        {
          key: "Mixing with",
          value: rest.row.original.mixingProvider
            ? rest.row.original.mixingProvider.toUpperCase()
            : "",
        },
      ];
    }

    if (rest.column.Header === "Price Factor Behaviour") {
      listItems = [
        {
          key: rest.row.original.factor_inplay
            ? rest.row.original.factor_inplay.toString().indexOf("-") > -1
              ? "Subtract from Price"
              : "Add on Price"
            : "",
          value: rest.row.original.factor_inplay
            ? rest.row.original.factor_inplay.toString().replace("-", "") + " Point/s"
            : "Odds Price doesn't change",
        },
      ];
    }

    return (
      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {listItems.map((item, index) => {
                return (
                  <div key={index} style={{ width: "180px", display: "inline-flex" }}>
                    {item.key}
                    {item.key ? ": " : ""} {item.value}
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        }
      >
        <Button>
          {value}
          <span style={{ paddingLeft: "5px" }}> </span>
          <Icon>info_outlined</Icon>
        </Button>
      </HtmlTooltip>
    );
  }

  function formatMarketsSetting({ value, ...rest }) {
    return value ? (
      <SoftBox className="market-setting-menu-holder">
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{ cursor: "pointer", lineHeight: 0, fontSize: "1rem", verticalAlign: "sub" }}
        >
          <Tooltip title="Change Markets Settings" placement="top">
            <Icon
              style={{
                display: rest.row.original.markets_setting_id ? "" : "none",
                color: rest.row.original.markets_setting_id
                  ? rest.row.original.operMarketSettings_id
                    ? "#ff000070"
                    : "rgb(203, 12, 159)"
                  : "",
              }}
              onClick={(e) =>
                handleMarketSettingSelection(e, {
                  action: "add",
                  data: rest.row.original.id,
                })
              }
            >
              {rest.row.original.markets_setting_id
                ? rest.row.original.operMarketSettings_id
                  ? "playlist_remove_icon"
                  : "playlist_add_circle_icon"
                : "playlist_add_icon"}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          style={{
            display:
              rest.row.original.markets_setting_id && !rest.row.original.operMarketSettings_id
                ? ""
                : "none",
          }}
          sx={{
            marginLeft: "5px",
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
          }}
        >
          <Tooltip title="Reset Changes" placement="top">
            <Icon
              onClick={(e) =>
                handleMarketSettingSelection(e, {
                  action: "remove",
                  data: rest.row.original.id,
                })
              }
            >
              undo_icon{" "}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftSelect
          className={rest.row.original.operMarketSettings_id ? "market-setting-menu" : "hide"}
          size="small"
          customSmall={true}
          options={marketSettingsOptions}
          value={
            marketSettingsOptions
              ? marketSettingsOptions.find(
                  (item) => item.value === rest.row.original.markets_setting_id
                )
              : null
          }
          onChange={(item) => rowMarketSettingsChange(item, rest.row.original)}
        ></SoftSelect>

        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            marginRight: "5px",
            display: oddSettingsEditCached
              ? rest.row.original.markets_setting_id
                ? "none"
                : ""
              : "none",
          }}
        >
          <Tooltip title="Edit Filter's Market Settings" placement="top">
            <Icon
              onClick={(e) =>
                handleMarketSettingSelection(e, {
                  action: "edit",
                  data: rest.row.original.id,
                })
              }
            >
              edit
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            display: oddSettingsEditCached
              ? rest.row.original.markets_setting_id
                ? "none"
                : ""
              : "none",
          }}
        >
          <Tooltip title="Delete Filter's Market Settings" placement="top">
            <Icon
              onClick={(e) =>
                handleMarketSettingSelection(e, {
                  action: "delete",
                  data: rest.row.original.id,
                })
              }
            >
              delete_outlined
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
    ) : (
      <SoftBox className="market-setting-menu-holder">
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            display: oddSettingsEditCached ? "" : "none",
          }}
        >
          <Tooltip
            title={
              rest.row.original.markets_setting_id
                ? "Change Market Settings"
                : "Add Filter's Market Settings"
            }
            placement="top"
          >
            <Icon
              style={{
                color: rest.row.original.markets_setting_id
                  ? "rgb(203, 12, 159)"
                  : rest.row.original.operMarketSettings_id
                  ? "#ff000070"
                  : "",
              }}
              onClick={(e) =>
                handleMarketSettingSelection(e, {
                  action: "add",
                  data: rest.row.original.id,
                  type: "pregame",
                })
              }
            >
              {rest.row.original.markets_setting_id
                ? "playlist_add_circle_icon"
                : rest.row.original.operMarketSettings_id
                ? "playlist_remove_icon"
                : "playlist_add_icon"}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            display:
              oddSettingsShowCached &&
              !oddSettingsEditCached &&
              !rest.row.original.operMarketSettings_id
                ? ""
                : "none",
          }}
        >
          None
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          style={{
            display:
              rest.row.original.markets_setting_id && !rest.row.original.operMarketSettings_id
                ? ""
                : "none",
          }}
          sx={{
            marginLeft: "5px",
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
          }}
        >
          <Tooltip title="Reset Changes" placement="top">
            <Icon
              onClick={(e) =>
                handleMarketSettingSelection(e, {
                  action: "remove",
                  data: rest.row.original.id,
                })
              }
            >
              undo_icon{" "}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftSelect
          className={rest.row.original.operMarketSettings_id ? "market-setting-menu" : "hide"}
          size="small"
          customSmall={true}
          options={marketSettingsOptions}
          value={
            marketSettingsOptions
              ? marketSettingsOptions.find(
                  (item) =>
                    item.value === value || item.value === rest.row.original.markets_setting_id
                )
              : null
          }
          onChange={(item) => rowMarketSettingsChange(item, rest.row.original)}
        ></SoftSelect>
      </SoftBox>
    );
  }

  function handleMarketSettingSelection(e, { action, data }) {
    e.preventDefault();

    setUpdateEnabled(false);
    setHiddenColumns([]);
    setDataTableData({ columns: [], rows: [] });
    let row = currentData.rows.find((row) => row.id == data);
    let sendSignal = false;

    if (action == "edit") {
      if (row) {
        row.operMarketSettings_id = row.operMarketSettings_id ? false : true;
        if (row.operMarketSettings_id) {
          row.markets_setting_id = row.markets_filter_config_id;
        } else {
          if (row.markets_filter_config_id) {
            delete row.markets_setting_id;
            sendSignal = true;
          }
        }
      }
    }

    if (action == "add") {
      if (row) {
        if (
          row[`markets_setting_id`] == row[`markets_filter_config_id`] &&
          row[`markets_setting_id`] != null
        ) {
          delete row[`markets_setting_id`];
          sendSignal = true;
        }
        row[`operMarketSettings_id`] = row[`operMarketSettings_id`] ? false : true;
      }
    }

    if (action == "remove") {
      if (row) {
        delete row[`markets_setting_id`];
        delete row[`operMarketSettings_id`];
        sendSignal = true;
      }
    }

    if (action == "delete") {
      if (row) {
        row[`markets_filter_config_id`] = null;
        row[`markets_setting_id`] = null;
        row[`operMarketSettings_id`] = false;
        sendSignal = true;
      }
    }

    if (sendSignal)
      handleSignals(new Event("MarketSettingsChange"), row.id, { original: row }, row.filtered);

    if (marketsFilters.length > 0) setUpdateEnabled(true);
    setHiddenColumns(
      oddSettingsShowCached
        ? ["selected"]
        : ["selected", "odds_filter_inplay_id", "odds_filter_pregame_id"]
    );
    setDataTableData(currentData);
  }

  function rowMarketSettingsChange(item, row) {
    row[`markets_setting_id`] = item.value;
    row.modified = true;
    row[`operMarketSettings_id`] = false;
    handleSignals(new Event("MarketSettingsChange"), row.id, { original: row }, row.filtered);
  }

  function formatOddSettingInplay({ value, ...rest }) {
    return value ? (
      <SoftBox className="odd-setting-menu-holder">
        {/* <SoftSelect
          customSmall={true}
          options={oddSettingsAvailable}
          value={oddSettingsAvailable.find((item) => item.value === value)}
        ></SoftSelect> */}
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{ cursor: "pointer", lineHeight: 0, fontSize: "1rem", verticalAlign: "sub" }}
        >
          <Tooltip title="Change Odd Settings" placement="top">
            <Icon
              style={{
                display: rest.row.original.odds_setting_inplay ? "" : "none",
                color: rest.row.original.odds_setting_inplay
                  ? rest.row.original.operOddSettings_inplay
                    ? "#ff000070"
                    : "rgb(203, 12, 159)"
                  : "",
              }}
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "add",
                  data: rest.row.original.id,
                  type: "inplay",
                })
              }
            >
              {rest.row.original.odds_setting_inplay
                ? rest.row.original.operOddSettings_inplay
                  ? "playlist_remove_icon"
                  : "playlist_add_circle_icon"
                : "playlist_add_icon"}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          style={{
            display:
              rest.row.original.odds_setting_inplay && !rest.row.original.operOddSettings_inplay
                ? ""
                : "none",
          }}
          sx={{
            marginLeft: "5px",
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
          }}
        >
          <Tooltip title="Reset Changes" placement="top">
            <Icon
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "remove",
                  data: rest.row.original.id,
                  type: "inplay",
                })
              }
            >
              undo_icon{" "}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftSelect
          className={rest.row.original.operOddSettings_inplay ? "odd-setting-menu" : "hide"}
          size="small"
          customSmall={true}
          options={oddSettingsOptions}
          value={
            oddSettingsOptions
              ? oddSettingsOptions.find(
                  (item) => item.value === rest.row.original.odds_setting_inplay
                )
              : null
          }
          onChange={(item) => rowOddSettingsChange(item, rest.row.original, "inplay")}
        ></SoftSelect>
        <HtmlTooltip
          placement="right"
          title={
            <React.Fragment>
              <div style={{}}>
                {rest.row.original.odd_settings_info_inplay.map((item, index) => {
                  return (
                    <div key={index} style={{}}>
                      <div style={{ fontWeight: "bold" }}>{item.title}</div>
                      <ul style={{ marginLeft: "5px", paddingLeft: "10px" }}>
                        {item.settings.map((s, i) => {
                          let print = s.value ? (s.key ? s.key + ": " + s.value : s.value) : "";
                          return print == "" ? false : <li key={i}>{print}</li>;
                        })}
                      </ul>
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          }
        >
          <Button
            sx={{
              maxWidth: "15px",
              width: "15px",
              minWidth: "10px",
              marginRight: "5px",
              display: rest.row.original.odds_setting_inplay ? "none" : "",
            }}
          >
            <Icon>info_outlined</Icon>
          </Button>
        </HtmlTooltip>

        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            marginRight: "5px",
            display: oddSettingsEditCached
              ? rest.row.original.odds_setting_inplay
                ? "none"
                : ""
              : "none",
          }}
        >
          <Tooltip title="Edit Filter's Odd Settings" placement="top">
            <Icon
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "edit",
                  data: rest.row.original.id,
                  type: "inplay",
                })
              }
            >
              edit
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            display: oddSettingsEditCached
              ? rest.row.original.odds_setting_inplay
                ? "none"
                : ""
              : "none",
          }}
        >
          <Tooltip title="Delete Filter's Odd Settings" placement="top">
            <Icon
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "delete",
                  data: rest.row.original.id,
                  type: "inplay",
                })
              }
            >
              delete_outlined
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
    ) : (
      <SoftBox className="odd-setting-menu-holder">
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            display: oddSettingsEditCached ? "" : "none",
          }}
        >
          <Tooltip
            title={
              rest.row.original.odds_setting_inplay
                ? "Change Odd Settings"
                : "Add Filter's Odd Settings"
            }
            placement="top"
          >
            <Icon
              style={{
                color: rest.row.original.odds_setting_inplay
                  ? "rgb(203, 12, 159)"
                  : rest.row.original.operOddSettings_inplay
                  ? "#ff000070"
                  : "",
              }}
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "add",
                  data: rest.row.original.id,
                  type: "inplay",
                })
              }
            >
              {rest.row.original.odds_setting_inplay
                ? "playlist_add_circle_icon"
                : rest.row.original.operOddSettings_inplay
                ? "playlist_remove_icon"
                : "playlist_add_icon"}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            display:
              oddSettingsShowCached &&
              !oddSettingsEditCached &&
              !rest.row.original.odds_setting_inplay
                ? ""
                : "none",
          }}
        >
          None
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          style={{
            display:
              rest.row.original.odds_setting_inplay && !rest.row.original.operOddSettings_inplay
                ? ""
                : "none",
          }}
          sx={{
            marginLeft: "5px",
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
          }}
        >
          <Tooltip title="Reset Changes" placement="top">
            <Icon
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "remove",
                  data: rest.row.original.id,
                  type: "inplay",
                })
              }
            >
              undo_icon{" "}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftSelect
          className={rest.row.original.operOddSettings_inplay ? "odd-setting-menu" : "hide"}
          size="small"
          customSmall={true}
          options={oddSettingsOptions}
          value={
            oddSettingsOptions
              ? oddSettingsOptions.find(
                  (item) =>
                    item.value === value || item.value === rest.row.original.odds_setting_inplay
                )
              : null
          }
          onChange={(item) => rowOddSettingsChange(item, rest.row.original, "inplay")}
        ></SoftSelect>
      </SoftBox>
    );
  }

  function formatOddSettingPregame({ value, ...rest }) {
    return value ? (
      <SoftBox className="odd-setting-menu-holder">
        {/* <SoftSelect
          customSmall={true}
          options={oddSettingsAvailable}
          value={oddSettingsAvailable.find((item) => item.value === value)}
        ></SoftSelect> */}
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{ cursor: "pointer", lineHeight: 0, fontSize: "1rem", verticalAlign: "sub" }}
        >
          <Tooltip title="Change Odd Settings" placement="top">
            <Icon
              style={{
                display: rest.row.original.odds_setting_pregame ? "" : "none",
                color: rest.row.original.odds_setting_pregame
                  ? rest.row.original.operOddSettings_pregame
                    ? "#ff000070"
                    : "rgb(203, 12, 159)"
                  : "",
              }}
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "add",
                  data: rest.row.original.id,
                  type: "pregame",
                })
              }
            >
              {rest.row.original.odds_setting_pregame
                ? rest.row.original.operOddSettings_pregame
                  ? "playlist_remove_icon"
                  : "playlist_add_circle_icon"
                : "playlist_add_icon"}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          style={{
            display:
              rest.row.original.odds_setting_pregame && !rest.row.original.operOddSettings_pregame
                ? ""
                : "none",
          }}
          sx={{
            marginLeft: "5px",
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
          }}
        >
          <Tooltip title="Reset Changes" placement="top">
            <Icon
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "remove",
                  data: rest.row.original.id,
                  type: "pregame",
                })
              }
            >
              undo_icon{" "}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftSelect
          className={rest.row.original.operOddSettings_pregame ? "odd-setting-menu" : "hide"}
          size="small"
          customSmall={true}
          options={oddSettingsOptions}
          value={
            oddSettingsOptions
              ? oddSettingsOptions.find(
                  (item) => item.value === rest.row.original.odds_setting_pregame
                )
              : null
          }
          onChange={(item) => rowOddSettingsChange(item, rest.row.original, "pregame")}
        ></SoftSelect>
        <HtmlTooltip
          placement="right"
          title={
            <React.Fragment>
              <div style={{}}>
                {rest.row.original.odd_settings_info_pregame.map((item, index) => {
                  return (
                    <div key={index} style={{}}>
                      <div style={{ fontWeight: "bold" }}>{item.title}</div>
                      <ul style={{ marginLeft: "5px", paddingLeft: "10px" }}>
                        {item.settings.map((s, i) => {
                          let print = s.value ? (s.key ? s.key + ": " + s.value : s.value) : "";
                          return print == "" ? false : <li key={i}>{print}</li>;
                        })}
                      </ul>
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          }
        >
          <Button
            sx={{
              maxWidth: "15px",
              width: "15px",
              minWidth: "10px",
              marginRight: "5px",
              display: rest.row.original.odds_setting_pregame ? "none" : "",
            }}
          >
            <Icon>info_outlined</Icon>
          </Button>
        </HtmlTooltip>

        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            marginRight: "5px",
            display: oddSettingsEditCached
              ? rest.row.original.odds_setting_pregame
                ? "none"
                : ""
              : "none",
          }}
        >
          <Tooltip title="Edit Filter's Odd Settings" placement="top">
            <Icon
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "edit",
                  data: rest.row.original.id,
                  type: "pregame",
                })
              }
            >
              edit
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            display: oddSettingsEditCached
              ? rest.row.original.odds_setting_pregame
                ? "none"
                : ""
              : "none",
          }}
        >
          <Tooltip title="Delete Filter's Odd Settings" placement="top">
            <Icon
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "delete",
                  data: rest.row.original.id,
                  type: "pregame",
                })
              }
            >
              delete_outlined
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
    ) : (
      <SoftBox className="odd-setting-menu-holder">
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            display: oddSettingsEditCached ? "" : "none",
          }}
        >
          <Tooltip
            title={
              rest.row.original.odds_setting_pregame
                ? "Change Odd Settings"
                : "Add Filter's Odd Settings"
            }
            placement="top"
          >
            <Icon
              style={{
                color: rest.row.original.odds_setting_pregame
                  ? "rgb(203, 12, 159)"
                  : rest.row.original.operOddSettings_pregame
                  ? "#ff000070"
                  : "",
              }}
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "add",
                  data: rest.row.original.id,
                  type: "pregame",
                })
              }
            >
              {rest.row.original.odds_setting_pregame
                ? "playlist_add_circle_icon"
                : rest.row.original.operOddSettings_pregame
                ? "playlist_remove_icon"
                : "playlist_add_icon"}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
            display:
              oddSettingsShowCached &&
              !oddSettingsEditCached &&
              !rest.row.original.operOddSettings_pregame
                ? ""
                : "none",
          }}
        >
          None
        </SoftTypography>
        <SoftTypography
          variant="text"
          color="secondary"
          style={{
            display:
              rest.row.original.odds_setting_pregame && !rest.row.original.operOddSettings_pregame
                ? ""
                : "none",
          }}
          sx={{
            marginLeft: "5px",
            cursor: "pointer",
            lineHeight: 0,
            fontSize: "1rem",
            verticalAlign: "sub",
          }}
        >
          <Tooltip title="Reset Changes" placement="top">
            <Icon
              onClick={(e) =>
                handleOddSettingSelection(e, {
                  action: "remove",
                  data: rest.row.original.id,
                  type: "pregame",
                })
              }
            >
              undo_icon{" "}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftSelect
          className={rest.row.original.operOddSettings_pregame ? "odd-setting-menu" : "hide"}
          size="small"
          customSmall={true}
          options={oddSettingsOptions}
          value={
            oddSettingsOptions
              ? oddSettingsOptions.find(
                  (item) =>
                    item.value === value || item.value === rest.row.original.odds_setting_pregame
                )
              : null
          }
          onChange={(item) => rowOddSettingsChange(item, rest.row.original, "pregame")}
        ></SoftSelect>
      </SoftBox>
    );
  }

  function makerollover({ value, ...rest }) {
    let listItems = value ? value : [];

    return (
      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {/* <div style={{ display: "block" }}> */}
              {listItems.map((item, index) => {
                return (
                  <div key={index} style={{ width: "150px", display: "inline-flex" }}>
                    {item}
                  </div>
                );
              })}
              {/* </div> */}
            </div>
          </React.Fragment>
        }
      >
        <Button>
          {listItems.length} {/* {value.split(",").length} */}
          <span style={{ paddingLeft: "5px" }}> </span>
          <Icon>info_outlined</Icon>
        </Button>
      </HtmlTooltip>
    );
  }

  function makeList({ value, ...rest }) {
    let listItems = value.split(",");

    return (
      <>
        {listItems.map((item) => {
          return (
            <SoftBadge
              style={{ marginRight: "3px" }}
              key={item}
              variant="gradient"
              color={item === "inplay" ? "info" : "secondary"}
              size="xs"
              badgeContent={item}
              container
            />
          );
        })}
      </>
    );
  }

  function showEnabled({ value, ...rest }) {
    return (
      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <div style={{ display: "flex", flexWrap: "wrap" }}>{rest.row.original.status}</div>
          </React.Fragment>
        }
      >
        <span
          style={{
            paddingLeft: "5px",
            color: rest.row.original.status == "Enabled" ? "#cb0c9f" : "",
          }}
        >
          {value}
        </span>
      </HtmlTooltip>
    );
  }

  const handleOpenModal = (e, id, dataType) => {
    e.preventDefault();
    setReferenceToDelete(dataType);
    if (dataType == "filter") {
      setRecordToDelete(id);
    }

    if (dataType == "odd") {
      setOddSettingToEdit(id);
    }
    setDeleteModal(true);
  };

  const handleCloseModal = async (update, id) => {
    if (update) {
      //console.log("Delete confirmed, please Update!");

      // let delFiltersEndpoint = `/api/v1/templates/filter/${id}`;
      // let response = await delData(delFiltersEndpoint, { Authorization: getAuthorizationHeader() });
      // if (response) {
      //   deleteRecord(id);
      //   initData();
      // }

      let idToSend = id;
      function returnId() {
        return idToSend;
      }
      Swal.fire({
        title: "We proccess your request! ",
        html: "Please Wait a few seconds...",
        timerProgressBar: true,
        didOpen: async () => {
          Swal.showLoading();
          let delFiltersEndpoint =
            referenceToDelete == "filter"
              ? `/api/v1/templates/filter/${id}`
              : `/api/v1/oddsfilters/${id}`;
          let response = await delData(delFiltersEndpoint, {
            Authorization: getAuthorizationHeader(),
          });

          if (!response) {
            Swal.clickDeny();
          } else {
            if (response.status === 200) {
              deleteRecord(returnId());

              Swal.clickConfirm();
            }
          }
        },
        willClose: () => {},
        allowOutsideClick: false,
      }).then((result) => {
        /* Read more about handling dismissals below */
        initData();
        setDeleteModal(false);
        setRecordToDelete(0);
        if (result.isConfirmed) {
          Swal.fire("Request Sent!", `Live Data sent to the platform`, "success");
        }
        if (result.isDenied) {
          Swal.fire(
            "Error!",
            `Live Data didn't send to the platform. Please try again later!`,
            "error"
          );
        }
      });
    } else {
      //console.log("Delete canceled, do nothing!");
      setDeleteModal(false);
      setRecordToDelete(0);
    }
    if (referenceToDelete == "odd") handleCloseFilterOddModal(false);
  };

  async function initData() {
    if (!platform || platform == "" || !sports || !permissions) return;
    setLoading(true);
    let userData = getUserData();
    let templatePlatformId = platform.value;
    let templateName = null;
    if (userData.defaultPlatform && userData.defaultPlatform.value) {
      templatePlatformId = userData.defaultPlatform.value;
      setPlatformId(templatePlatformId);
    }
    let templateId = selectedTemplateOptionId;

    if (templateId) {
      if (parseFloat(templateId) >= 0) {
        templateId = parseFloat(templateId);
      } else {
        //routeChange(0);
        templateId = 0;
        return;
      }
    }

    let getTemplateDataEndpoint = templateId ? `/api/v1/templates/${templateId}` : null;
    let responseTemplate = getTemplateDataEndpoint
      ? await getData(
          getTemplateDataEndpoint,
          {
            Authorization: getAuthorizationHeader(),
          },
          null,
          abortController ? { signal: abortController.signal } : null
        )
      : null;
    if (responseTemplate != null) {
      if (
        responseTemplate.data.length == 0 ||
        templatePlatformId != responseTemplate.data[0].platform_id
      ) {
        //routeChange(0);
        templateId = 0;
        setPlatformId(templateId);
        setNewTemplateName("");
        setTemplateToEdit(null);
        setSelectedTemplatesOption({ value: 0, label: "All" });
      } else {
        templatePlatformId = responseTemplate.data[0].platform_id;
        templateName = responseTemplate.data[0].name;
        setPlatformId(templatePlatformId);
        setNewTemplateName(templateName);
        setTemplateToEdit(responseTemplate.data[0]);
      }
    } else {
      setSelectedTemplatesOption({ value: 0, label: "All" });
    }

    // let getFiltersEndpoint = templateId
    //   ? `/api/v1/templates/${templateId}/filters`
    //   : `/api/v1/platforms/${templatePlatformId}/filters`;
    let getFiltersEndpoint = `/api/v1/platforms/${templatePlatformId}/filters`;
    let response = await getData(
      getFiltersEndpoint,
      { Authorization: getAuthorizationHeader() },
      null,
      abortController ? { signal: abortController.signal } : null
    );
    let filteredData = [];
    let templatesSelectedOptions = null;
    if (response != null) {
      let templatesOptions = [{ value: 0, label: "All" }];

      response.data.forEach((element) => {
        element.selected = false;
        element.odds_filter_inplay_id = element.odd_filter_inplay;
        element.odds_filter_pregame_id = element.odd_filter_pregame;
        element.markets_filter_config_id = element.markets_setting_id;
        delete element.markets_setting_id;

        element.oddsLimitReaction_inplay = oddsReactions.find(
          (or) => or.value == element.barrier_reaction_type_inplay
        );
        element.oddsLimitReaction_inplay =
          element.oddsLimitReaction_inplay || element.oddsLimitReaction_inplay == 0
            ? element.oddsLimitReaction_inplay.label
            : "";
        element.lowerlimit_inplay = element.min_odd_barrier_inplay;
        element.upperlimit_inplay = element.max_odd_barrier_inplay;
        element.mixingType_inplay = mixingOptions.find(
          (mo) => mo.value == element.mixing_odd_type_inplay
        );
        element.mixingType_inplay =
          element.mixingType_inplay || element.mixingType_inplay == 0
            ? element.mixingType_inplay.label
            : "";
        element.mixing_providers_inplay =
          typeof element.mixing_providers_inplay == "string"
            ? element.mixing_providers_inplay.replace(/[{,},"]/g, "")
            : element.mixing_providers_inplay;
        if (element.mixing_providers_inplay == "NULL" || !element.mixing_providers_inplay) {
          element.mixing_providers_inplay = [];
        }
        element.mixingProviders_inplay =
          typeof element.mixing_providers_inplay == "object"
            ? element.mixing_providers_inplay.join(",")
            : "";
        element.factor_inplay = element.static_odd_reaction_inplay
          ? element.static_odd_reaction_inplay.toString()
          : "0";
        element.randomFactor_inplay = element.random_odd_reaction_inplay
          ? "Random Apply"
          : "Allways Apply";
        element.marginType_inplay = marginOptions.find(
          (mo) => mo.value == element.margin_type_inplay
        );
        element.marginType_inplay =
          element.marginType_inplay || element.marginType_inplay == 0
            ? element.marginType_inplay.label
            : "";
        element.marginPercent_inplay = element.margin_percent_inplay;
        element.suspension_type_inplay = oddsSuspensionType.find(
          (ost) => ost.value == element.suspension_type_inplay
        );

        element.oddsLimitReaction_pregame = oddsReactions.find(
          (or) => or.value == element.barrier_reaction_type_pregame
        );
        element.oddsLimitReaction_pregame =
          element.oddsLimitReaction_pregame || element.oddsLimitReaction_pregame == 0
            ? element.oddsLimitReaction_pregame.label
            : "";
        element.lowerlimit_pregame = element.min_odd_barrier_pregame;
        element.upperlimit_pregame = element.max_odd_barrier_pregame;
        element.mixingType_pregame = mixingOptions.find(
          (mo) => mo.value == element.mixing_odd_type_pregame
        );
        element.mixingType_pregame =
          element.mixingType_pregame || element.mixingType_pregame == 0
            ? element.mixingType_pregame.label
            : "";
        element.mixing_providers_pregame =
          typeof element.mixing_providers_pregame == "string"
            ? element.mixing_providers_pregame.replace(/[{,},"]/g, "")
            : element.mixing_providers_pregame;
        if (element.mixing_providers_pregame == "NULL" || !element.mixing_providers_pregame) {
          element.mixing_providers_pregame = [];
        }
        element.mixingProviders_pregame =
          typeof element.mixing_providers_pregame == "object"
            ? element.mixing_providers_pregame.join(",")
            : "";
        element.factor_pregame = element.static_odd_reaction_pregame
          ? element.static_odd_reaction_pregame.toString()
          : "0";
        element.randomFactor_ipregame = element.random_odd_reaction_pregame
          ? "Random Apply"
          : "Allways Apply";
        element.marginType_pregame = marginOptions.find(
          (mo) => mo.value == element.margin_type_pregame
        );
        element.marginType_pregame =
          element.marginType_pregame || element.marginType_pregame == 0
            ? element.marginType_pregame.label
            : "";
        element.marginPercent_pregame = element.margin_percent_pregame;
        element.suspension_type_pregame = oddsSuspensionType.find(
          (ost) => ost.value == element.suspension_type_pregame
        );

        let listItems = [
          {
            title: "Market Suspension",
            settings: [
              {
                key: "Action",
                value:
                  element.suspension_type_inplay || element.suspension_type_inplay == 0
                    ? element.suspension_type_inplay.label
                    : "No Action",
              },
              {
                key: "Providers Priority for Suspension",
                value: element.suspension_provider_inplay
                  ? element.suspension_provider_inplay
                      .split(",")
                      .map((sp) => providers.find((p) => p.value == sp)["label"])
                  : "-",
              },
            ],
          },
          {
            title: "Odds Limit Reaction",
            settings: [
              { key: "Action", value: element.oddsLimitReaction_inplay },
              { key: "min Price", value: element.lowerlimit_inplay },
              { key: "max Price", value: element.upperlimit_inplay },
            ],
          },
          {
            title: "Mixing Type",
            settings: [
              { key: "Action", value: element.mixingType_inplay },
              {
                key: element.mixingType_inplay == "No Mixing" ? null : "Mixing",
                value: element.mixingProviders_inplay ? element.mixingProviders_inplay : "",
              },
              {
                key: "Mixing Odd Limit",
                value: element.mixing_odd_limit_inplay ? element.mixing_odd_limit_inplay : "-",
              },
            ],
          },
          {
            title: "Price Factor Behaviour",
            settings: [
              {
                key: "Action",
                value:
                  element.static_odd_reaction_json_inplay &&
                  element.static_odd_reaction_json_inplay.length == 1 &&
                  JSON.stringify(element.static_odd_reaction_json_inplay[0].value) ==
                    JSON.stringify(defaultStaticOddReactionJson.value)
                    ? "Do Nothing"
                    : "Prices will be manipulated",
              },
            ],
          },
          {
            title: "Margin Behaviour",
            settings: [
              {
                key: "Action",
                value: element.marginType_inplay,
              },
              {
                key: "Margin",
                value: element.marginPercent_inplay ? element.marginPercent_inplay + "%" : null,
              },
            ],
          },
        ];

        element.odd_settings_info_inplay = listItems;

        listItems = [
          {
            title: "Market Suspension",
            settings: [
              {
                key: "Action",
                value: element.suspension_type_pregame
                  ? element.suspension_type_pregame.label
                  : "No Action",
              },
              {
                key: "Providers Priority for Suspension",
                value: element.suspension_provider_pregame
                  ? element.suspension_provider_pregame
                      .split(",")
                      .map((sp) => providers.find((p) => p.value == sp)["label"])
                  : "-",
              },
            ],
          },
          {
            title: "Odds Limit Reaction",
            settings: [
              { key: "Action", value: element.oddsLimitReaction_pregame },
              { key: "min Price", value: element.lowerlimit_pregame },
              { key: "max Price", value: element.upperlimit_pregame },
            ],
          },
          {
            title: "Mixing Type",
            settings: [
              { key: "Action", value: element.mixingType_pregame },
              {
                key: element.mixingType_pregame == "No Mixing" ? null : "Mixing",
                value: element.mixingProviders_pregame ? element.mixingProviders_pregame : "",
              },
              {
                key: "Mixing Odd Limit",
                value: element.mixing_odd_limit_pregame ? element.mixing_odd_limit_pregame : "-",
              },
            ],
          },
          {
            title: "Price Factor Behaviour",
            settings: [
              {
                key: "Action",
                value:
                  element.static_odd_reaction_json_pregame &&
                  element.static_odd_reaction_json_pregame.length == 1 &&
                  JSON.stringify(element.static_odd_reaction_json_pregame[0].value) ==
                    JSON.stringify(defaultStaticOddReactionJson.value)
                    ? "Do Nothing"
                    : "Prices will be manipulated",
              },
            ],
          },
          {
            title: "Margin Behaviour",
            settings: [
              {
                key: "Action",
                value: element.marginType_pregame,
              },
              {
                key: "Margin",
                value: element.marginPercent_pregame ? element.marginPercent_pregame + "%" : null,
              },
            ],
          },
        ];

        element.odd_settings_info_pregame = listItems;

        if (!templatesOptions.find((item) => item.value == element.template_id)) {
          templatesOptions.push({ value: element.template_id, label: element.template_name });
          if (templateId && element.template_id == templateId) {
            templatesSelectedOptions = { value: element.template_id, label: element.template_name };
          }
        }
        if (templateId) {
          if (element.template_id == parseFloat(templateId)) filteredData.push(element);
        } else {
          filteredData.push(element);
        }
      });

      if (!templateId) setSelectedTemplatesOption({ value: 0, label: "All" });

      setTemplatesOptions(templatesOptions);
      let selections = [];
      filteredData.map((el) => {
        el.providers = el.name;
        el.filter = el.id;
        el.template = el.template_name ? el.template_name : templateName ? templateName : "";
        el.template_id = el.template_id ? el.template_id : templateId ? templateId : null;
        el.types = el.type ? el.type : "";
        el.typeinplay = null;
        if (el.inplay == true) el.typeinplay = "inplay";
        el.typepreGame = null;
        if (el.pregame == true) el.typepreGame = "pregame";

        if (el.typeinplay) el.types = el.typeinplay;
        if (el.typepreGame)
          el.types = el.types != "" ? el.types + "," + el.typepreGame : el.typepreGame;

        el.competitions = el.competitions_count;

        el.sports = el.sports
          ? el.sports.split(",").map((s) => {
              let tmp = sports.find((i) => i.id == s * 1);
              return tmp.name;
            })
          : el.sports;

        (el.status = el.status ? "Enabled" : "Disabled"),
          (el.action = (
            <ActionCell
              templateId={parseInt(el.template_id)}
              filterId={el.id}
              feed={
                el.provider_id == 1000
                  ? el.odds_filter_inplay_id || el.odds_filter_pregame_id
                    ? true
                    : false
                  : true
              }
              handleDeleteAction={(e) => handleOpenModal(e, el.id, "filter")}
            />
          ));
        selections.push({
          value: el.template_id + "--" + el.filter + "--" + el.provider_id,
          label: el.name,
        });
      });
      setFiltersSelection(selections);
    } else {
    }

    let data = { ...dataTableData };
    data.rows = filteredData;

    currentData = { ...data };

    setHiddenColumns(
      oddSettingsShowCached
        ? ["selected"]
        : ["selected", "odds_filter_inplay_id", "odds_filter_pregame_id"]
    );
    setDataTableData(data);
    if (templatesSelectedOptions) setSelectedTemplatesOption(templatesSelectedOptions);

    setLoading(false);
  }

  function deleteRecord(id) {
    //console.log("deleteRecord:", id);
    let initData = { ...dataTableData };
    let initDataRows = [...dataTableData.rows];

    let indexToRemove = initDataRows.findIndex((template) => template.id === id);
    initDataRows.splice(indexToRemove, 1);

    initData.rows = initDataRows;
    setDataTableData(initData);
  }

  const handleTemplateSelect = (item) => {
    setSelectedTemplatesOption(item);
    //routeChange(item.value);
    setselectedTemplateOptionId(item.value);
    templateId = item.value;
  };

  /**
   *
   * @param {*} update
   * @param {*} name
   */
  const handleCloseFilterOddModal = async (update) => {
    setOddSettingToEdit(0);
    if (update) {
      await initData();
    } else {
      //console.log("Creation canceled, do nothing!");
    }
    //setFiltersSelection([]);
    setRecordSelectedProvider(null);
    setRecordSelectedTemplate("0");
    setRecordSelectedTemplateName("0");
    setOddSettingToEdit(0);

    setShowOddFilterCreateModal(false);
  };

  async function fetchOddsSettings() {
    let selectedPlatformId = platform.value;
    let getTemplatesEndpoint = `/api/v1/oddsfilters/platforms/${selectedPlatformId}`;
    let response = await getData(
      getTemplatesEndpoint,
      { Authorization: getAuthorizationHeader() },
      null,
      abortController ? { signal: abortController.signal } : null
    );
    if (response != null) {
      oddSettingsOptions = response.data.map((r) => {
        return { value: r.id, label: r.name };
      });
      setSettingsAvailable(oddSettingsOptions);
    }
  }

  async function fetchMarketsSettings() {
    // if (oddSettingsOptions.length > 0) return;
    let selectedPlatformId = platform.value;
    let getTemplatesEndpoint = `/api/v1/marketsfilters/platform/${selectedPlatformId}`;
    let response = await getData(
      getTemplatesEndpoint,
      { Authorization: getAuthorizationHeader() },
      null,
      abortController ? { signal: abortController.signal } : null
    );
    if (response != null) {      marketSettingsOptions = response.data.map((r) => {
        return { value: r.id, label: r.name };
      });
      setMarketSettingsAvailable(marketSettingsOptions);
    }
  }

  async function handleSignals(e, id, row, filtered) {
    e.preventDefault();
    //console.log(row);
    setUpdateEnabled(false);
    setHiddenColumns([]);
    setDataTableData({ columns: [], rows: [] });

    let dataRow = currentData.rows.find((item) => item.id == row.original.id);
    if (e.type != "OddSettingsChange" && e.type != "MarketSettingsChange") {
      if (dataRow.hasOwnProperty("operFiltered")) {
        dataRow.operFiltered = !dataRow.operFiltered;
        if (!filtered && !dataRow.operFiltered) {
          delete dataRow.operFiltered;
        }
        if (filtered && dataRow.operFiltered) {
          delete dataRow.operFiltered;
        }
      } else {
        dataRow.operFiltered = filtered ? false : true;
        if (dataRow.operFiltered) dataRow.modified = true;
        else dataRow.modified = false;
      }
    }

    const marketFilter = {
      filter_id: id,
      provider_id: row.original.provider_id,
      platform_id: userData.defaultPlatform.value,
      template_id: row.original.template_id,
      filtered: dataRow.filtered,
      operFiltered: dataRow.operFiltered,
      odds_setting_inplay: dataRow.odds_setting_inplay
        ? dataRow.odds_setting_inplay
        : dataRow.odds_filter_inplay_id,
      odds_setting_pregame: dataRow.odds_setting_pregame
        ? dataRow.odds_setting_pregame
        : dataRow.odds_filter_pregame_id,
      sport_id: dataRow.sport_id,
      odds_filter_config_id: dataRow.odds_filter_config_id,
      markets_filter_config_id: dataRow.markets_setting_id
        ? dataRow.markets_setting_id
        : dataRow.markets_filter_config_id,
      type: dataRow.type,
    };

    const marketFilterIndex = marketsFilters.findIndex(
      (item) => item.filter_id === marketFilter.filter_id
    );

    if (
      !dataRow.hasOwnProperty("operFiltered") &&
      !dataRow.hasOwnProperty("odds_setting_inplay") &&
      !dataRow.hasOwnProperty("odds_setting_pregame") &&
      !dataRow.hasOwnProperty("markets_setting_id")
    ) {
      if (marketFilterIndex > -1) {
        marketsFilters.splice(marketFilterIndex, 1);
        dataRow.modified = false;
      }
      if (marketsFilters.length > 0) setUpdateEnabled(true);

      if (marketFilterIndex > -1 && marketsFilters.length == 0) {
        setApiresponse("error");
        setApiResponseMsg("There are NO unsaved filters changes.");
        setNotification(true);
        setShowDialog(false);
      }

      setHiddenColumns(
        oddSettingsShow
          ? ["selected"]
          : ["selected", "odds_filter_inplay_id", "odds_filter_pregame_id"]
      );
      setDataTableData(currentData);

      return;
    } else {
      dataRow.modified = true;
    }

    if (
      dataRow.hasOwnProperty("odds_setting_inplay") ||
      dataRow.hasOwnProperty("odds_setting_pregame")
    ) {
      marketFilter.odds_setting_change = true;
    }
    if (dataRow.hasOwnProperty("markets_setting_id")) {
      marketFilter.market_setting_change = true;
    }

    setHiddenColumns(
      oddSettingsShowCached
        ? ["selected"]
        : ["selected", "odds_filter_inplay_id", "odds_filter_pregame_id"]
    );
    setDataTableData(currentData);

    if (marketFilterIndex < 0) {
      marketsFilters.push(marketFilter);
    } else {
      marketsFilters[marketFilterIndex] = marketFilter;
    }

    if (marketsFilters.length > 0) {
      setUpdateEnabled(true);
      setApiresponse("success");
      setApiResponseMsg("There are unsaved filters changes.");
      setNotification(true);
      setShowDialog(true);
    }
  }

  const handleTableDataChanges = async ({ key, value, extra }) => {
    //console.log(key, ":", value, extra);
    if (key == "refresh") {
      initData();
    }

    if (key == "selectOne") {
      setUpdateEnabled(false);
      setHiddenColumns([]);
      setDataTableData({ columns: [], rows: [] });

      let dataRow = currentData.rows.find((item) => item.id == value);
      dataRow.selected = extra;
      let rows = selectedRows;
      let rowExist = rows.findIndex((item) => item.id == value);
      if (rowExist > -1) {
        if (!extra) {
          rows.splice(rowExist, 1);
          setSelectedRows(rows);
        }
      } else {
        if (extra) {
          rows.push(dataRow);
          setSelectedRows(rows);
        }
      }
      if (marketsFilters.length > 0) setUpdateEnabled(true);

      setHiddenColumns(
        oddSettingsShow
          ? ["selected"]
          : ["selected", "odds_filter_inplay_id", "odds_filter_pregame_id"]
      );
      setDataTableData(currentData);
    }

    if (key == "selectAll") {
      setUpdateEnabled(false);
      setHiddenColumns([]);
      setDataTableData({ columns: [], rows: [] });
      let dataRows = currentData.rows;
      if (extra == "all") {
        dataRows = value;
        for (let index = 0; index < dataRows.length; index++) {
          const dataRow = dataRows[index];
          dataRow.selected = true;
        }
        setSelectedRows(dataRows);
      } else if (extra == "none") {
        dataRows = value;
        for (let index = 0; index < dataRows.length; index++) {
          const dataRow = dataRows[index];
          dataRow.selected = false;
        }
        setSelectedRows([]);
      }
      if (marketsFilters.length > 0) setUpdateEnabled(true);

      setHiddenColumns(
        oddSettingsShow
          ? ["selected"]
          : ["selected", "odds_filter_inplay_id", "odds_filter_pregame_id"]
      );
      setDataTableData(currentData);
    }
  };

  function marketSettingsChange(item, type) {
    for (let index = 0; index < selectedRows.length; index++) {
      const filter = selectedRows[index];
      filter[`markets_setting_id`] = item.value;
      filter.modified = true;
      handleSignals(
        new Event("MarketSettingsChange"),
        filter.id,
        { original: filter },
        filter.filtered
      );
    }
  }

  function oddSettingsChange(item, type) {
    for (let index = 0; index < selectedRows.length; index++) {
      const filter = selectedRows[index];
      filter[`odds_setting_${type}`] = item.value;
      filter.modified = true;
      handleSignals(
        new Event("OddSettingsChange"),
        filter.id,
        { original: filter },
        filter.filtered
      );
    }
  }

  function handleOddSettingSelection(e, { action, data, type }) {
    e.preventDefault();

    setUpdateEnabled(false);
    setHiddenColumns([]);
    setDataTableData({ columns: [], rows: [] });
    let row = currentData.rows.find((row) => row.id == data);
    let sendSignal = false;

    if (action == "edit") {
      if (row) {
        if (type == "inplay") {
          row.operOddSettings_inplay = row.operOddSettings_inplay ? false : true;
          if (row.operOddSettings_inplay) {
            row.odds_setting_inplay = row.odds_filter_inplay_id;
          } else {
            if (row.odds_filter_inplay_id) {
              delete row.odds_setting_inplay;
              sendSignal = true;
            }
          }
        }
        if (type == "pregame") {
          row.operOddSettings_pregame = row.operOddSettings_pregame ? false : true;
          if (row.operOddSettings_pregame) {
            row.odds_setting_pregame = row.odds_filter_pregame_id;
          } else {
            if (row.odds_filter_pregame_id) {
              delete row.odds_setting_pregame;
              sendSignal = true;
            }
          }
        }
      }
    }

    if (action == "add") {
      if (row) {
        if (
          row[`odds_setting_${type}`] == row[`odds_filter_${type}_id`] &&
          row[`odds_setting_${type}`] != null
        ) {
          delete row[`odds_setting_${type}`];
          sendSignal = true;
        }
        row[`operOddSettings_${type}`] = row[`operOddSettings_${type}`] ? false : true;
      }
    }

    if (action == "remove") {
      if (row) {
        delete row[`odds_setting_${type}`];
        delete row[`operOddSettings_${type}`];
        sendSignal = true;
      }
    }

    if (action == "delete") {
      if (row) {
        row[`odds_filter_${type}_id`] = null;
        row[`odds_setting_${type}`] = null;
        row[`operOddSettings_${type}`] = false;
        sendSignal = true;
      }
    }

    if (sendSignal)
      handleSignals(new Event("OddSettingsChange"), row.id, { original: row }, row.filtered);

    if (marketsFilters.length > 0) setUpdateEnabled(true);
    setHiddenColumns(
      oddSettingsShowCached
        ? ["selected"]
        : ["selected", "odds_filter_inplay_id", "odds_filter_pregame_id"]
    );
    setDataTableData(currentData);
  }

  function rowOddSettingsChange(item, row, type) {
    row[`odds_setting_${type}`] = item.value;
    row.modified = true;
    row[`operOddSettings_${type}`] = false;
    handleSignals(new Event("OddSettingsChange"), row.id, { original: row }, row.filtered);
  }

  const getMarketsFilters = () => {
    return marketsFilters;
  };

  const handleUpdate = () => {
    let selectedPlatformId = platform.value;
    Swal.fire({
      title: "We proccess your request! ",
      html: "Wait for few seconds...",
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading();
        const oddsSettingsUpdateEndpoint = `/api/v1/oddsfilters/platform/${selectedPlatformId}/configs/assign`;
        const marketsSettingsUpdateEndpoint = `/api/v1/marketsfilters/platform/${selectedPlatformId}/config/assign`;
        const marketsFiltersVar = getMarketsFilters();
        let oddsSettings = [];
        let marketsSettings = [];

        for (let index = 0; index < marketsFiltersVar.length; index++) {
          const template = marketsFiltersVar[index];
          if (template.market_setting_change) {
            let marketsSetting = {
              template_id: template.template_id,
              provider_id: template.provider_id,
              sport_id: null,
              competition_id: null,
              market_filter_config_id: template.markets_filter_config_id,
            };
            marketsSettings.push(marketsSetting);
          }
          if (template.odds_setting_change) {
            delete template.markets_filter_config_id;
            delete template.odds_setting_change;
            delete template.market_setting_change;
            oddsSettings.push(template);
          }
        }

        let response = null;
        if (oddsSettings.length > 0) {
          response = await putData(oddsSettingsUpdateEndpoint, oddsSettings, {
            Authorization: getAuthorizationHeader(),
          });
        }

        if (marketsSettings.length > 0) {
          response = await putData(marketsSettingsUpdateEndpoint, marketsSettings, {
            Authorization: getAuthorizationHeader(),
          });
        }

        if (!response) {
          Swal.clickDeny();
        } else {
          if (response.status === 200) {
            Swal.clickConfirm();
          }
        }
      },
      willClose: () => {},
      allowOutsideClick: false,
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        //console.log("I was closed by the timer");
        //routeChange();
      }

      setUpdateEnabled(true);
      setUpdateEnabled(false);
      resetData();
      setShowDialog(false);
      if (result.isConfirmed) {
        Swal.fire("Request Sent!", `Live Data sent to the platform`, "success");
      }
      if (result.isDenied) {
        Swal.fire(
          "Error!",
          `Live Data didn't send to the platform. Please try again later!`,
          "error"
        );
      }
    });
  };

  const handleCancelEdit = async () => {
    if (marketsFilters.length > 0) {
      Swal.fire({
        title: `Unsaved Data!`,
        html:
          "You are going Lose some Odds Settings you have already set.</br></br>" +
          marketsFilters.length +
          " Odds Settings have been changed. </br></br> Are you Sure?",
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: "Yes, Cancel them!",
        denyButtonText: "Cancel",
        icon: "warning",
        confirmButtonColor: "#87cb16",
        denyButtonColor: "#ff4a55",
      }).then(async (result) => {
        if (result.isConfirmed) {
          //console.log("Modal confirmed");
          setUpdateEnabled(true);
          setUpdateEnabled(false);
          resetData();
          setShowDialog(false);
        }
      });
    } else {
      //console.log("Nothing have been changed");
    }
  };

  async function resetData() {
    marketsFilters = [];
    setSelectedRows([]);
    setShowDialog(false);
    initData();
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  const handlePermissions = (permissions) => {
    setUserPermissions(permissions);
    let editOddSettingsEnabled = false;
    let showOddSettingsEnabled = false;

    //console.log(permissions);

    for (let index = 0; index < permissions.length; index++) {
      const permission = permissions[index];
      if (permission == "super") {
        editOddSettingsEnabled = true;
        showOddSettingsEnabled = true;
      }
      if (permission == "feed-settings-odds-edit") {
        editOddSettingsEnabled = true;
        showOddSettingsEnabled = true;
        break;
      }
      if (permission == "feed-settings-odds-show") {
        showOddSettingsEnabled = true;
      }
    }

    setOddSettingsEdit(editOddSettingsEnabled);
    oddSettingsEditCached = editOddSettingsEnabled;
    setOddSettingsShow(showOddSettingsEnabled);
    oddSettingsShowCached = showOddSettingsEnabled;
  };

  useEffect(() => {
    if (platform) {
      fetchOddsSettings();
      fetchMarketsSettings();
    }
    if (permissions.length > 0) handlePermissions(permissions);
    initData();
  }, [platform.label, selectedTemplateOptionId, sports, permissions]);

  useEffect(() => {
    if (location.state && location.state.templateId) {
      // let item = templatesOptions.find((it) => it.value == location.state.templateId);
      // setSelectedTemplatesOption(item);
      //routeChange(item.value);
      setselectedTemplateOptionId(location.state.templateId);
      templateId = location.state.templateId;
    }
  }, [location]);

  useEffect(() => {
    return () => {
      if (abortController) {
        // console.log("abortController");
        abortController.abort();
      }
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        key={"topright"}
        open={notification}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={`${apiResponse}`}
          sx={{ width: "100%" }}
          className={`api-${apiResponse}-notifications`}
        >
          {apiResponseMsg}
        </Alert>
      </Snackbar>
      <CheckObjectDeletion
        referenceId={referenceToDelete == "filter" ? recordToDelete : oddSettingToEdit}
        reference={referenceToDelete}
        showModal={showCreateModal}
        signalCloseModal={handleCloseModal}
      ></CheckObjectDeletion>
      <SoftBox my={3}>
        <Card>
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            p={3}
            sx={{ paddingBottom: "0px !important" }}
          >
            <SoftBox lineHeight={1}>
              <SoftTypography variant="h5" fontWeight="medium">
                Your Filters
              </SoftTypography>
              <SoftTypography variant="button" fontWeight="regular" color="text">
                Here you can moderate the filters of the selected Template
              </SoftTypography>
            </SoftBox>
            <Stack spacing={1} direction="row">
              <Link to={`/feed-settings/filters/create-filter`}>
                <SoftButton variant="gradient" color="info" size="small">
                  + new Filter
                </SoftButton>
              </Link>
            </Stack>
          </SoftBox>
          <SoftBox p={3} sx={{ paddingTop: "0px !important", zIndex: 3 }}>
            <Grid container spacing={3}>
              <Grid item xs={3} md={3}>
                <SoftSelect
                  value={selectedTemplateOption}
                  options={templatesOptions}
                  onChange={handleTemplateSelect}
                  size="small"
                />
              </Grid>
              <Grid item xs={3} md={6}></Grid>
              <Grid item xs={3} md={3} style={{ textAlign: "right" }}>
                <SoftBox lineHeight={1} sx={{ display: oddSettingsEditCached ? "" : "none" }}>
                  <Button onClick={handleCancelEdit} disabled={updateEnabled ? false : true}>
                    Cancel
                  </Button>
                  <Button onClick={handleUpdate} disabled={updateEnabled ? false : true}>
                    Update
                  </Button>
                </SoftBox>
              </Grid>
            </Grid>
          </SoftBox>
          <SoftBox
            pt={2}
            pl={3}
            pr={3}
            sx={{
              display: oddSettingsEditCached ? (selectedRows.length > 0 ? "" : "none") : "none",
            }}
            className="table-multiselected-action-filter"
          >
            <Grid
              container
              sx={{
                backgroundImage: "linear-gradient(to right, #FFFFFF, #f8f9fa, #ffffff)",
                minHeight: "90px",
                maxHeight: "90px",
                color: "red !important",
                // textAlign: "right !important",
              }}
            >
              <Grid
                item
                mr={2}
                md={6}
                sm={6}
                sx={{
                  textAlign: "right !important",
                  width: "200px !important",
                  maxWidth: "fit-content !important",
                  // paddingLeft: "50px !important",
                }}
              >
                <SoftTypography variant="caption"> </SoftTypography>
                <SoftTypography
                  variant="caption"
                  style={{ textAlign: "right !important", lineHeight: 10 }}
                >
                  Apply to the selected Filters:{" "}
                </SoftTypography>
              </Grid>
              <Grid item mr={2} style={{ zIndex: 3 }}>
                <SoftTypography variant="caption">Markets Settings: </SoftTypography>
                <SoftSelect
                  size="small"
                  customSmall={true}
                  options={marketSettingsOptions}
                  onChange={(item) => marketSettingsChange(item, "inplay")}
                ></SoftSelect>
              </Grid>
              <Grid item mr={2} style={{ zIndex: 3 }}>
                <SoftTypography variant="caption">Odds Settings inPlay: </SoftTypography>
                <SoftSelect
                  size="small"
                  customSmall={true}
                  options={oddSettingsOptions}
                  onChange={(item) => oddSettingsChange(item, "inplay")}
                ></SoftSelect>
              </Grid>
              <Grid item mr={2} style={{ zIndex: 3 }}>
                <SoftTypography variant="caption">Odds Settings preGame: </SoftTypography>
                <SoftSelect
                  size="small"
                  customSmall={true}
                  options={oddSettingsOptions}
                  onChange={(item) => oddSettingsChange(item, "pregame")}
                ></SoftSelect>
              </Grid>
            </Grid>
          </SoftBox>
          <DataTable
            table={dataTableData}
            entriesPerPage={{
              defaultValue: 10,
              entries: [5, 10, 15, 20, 25],
            }}
            openBackDrop={loading}
            hiddenColumns={hiddenColumns}
            autoResetPageDefault={true}
            autoResetGlobalFilter={true}
            autoResetSortByDefault={true}
            canSearch
            checkboxSelection={oddSettingsEditCached}
            refreshEnabled={true}
            informParent={handleTableDataChanges}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

// Typechecking props of the CreateTemplate
GeneralFiltersList.propTypes = {
  templateId: PropTypes.string,
};

export default GeneralFiltersList;
